import { SkusCarouselProps } from '@/types/props/components/skus';
import SkuCardDesktop from '../../cards/sku/desktop/SkuCardDesktop';
import { BasicCarouselDesktop } from '../BasicCarousels';
import { getReactKey } from '@/utilites/react/react.util';
export default function SkusCarouselDesktop({
  skus,
  userId,
}: SkusCarouselProps) {
  return (
    <div className="max-nine:!tw-hidden">
      <BasicCarouselDesktop>
        {skus.map((sku, index) => (
          <SkuCardDesktop
            key={getReactKey.skuCarousel.desktop(sku, index)}
            sku={sku}
          />
        ))}
      </BasicCarouselDesktop>
    </div>
  );
}
